<template>
    <div
        class="selectpicker-wrap"
        :class="{
            'selectpicker--not-selected': isArray(value) && !value.length,
            'selectpicker-wrap--collections': selectTitle === 'Коллекция:'
        }"
    >
        <div
            v-if="
                isMultiple &&
                    (isArray(value) && value.length) &&
                    !showMultiSelectedTitles
            "
            class="selectpicker-label"
        >
            {{ isArray(value) && value.length }}
        </div>
        <select
            ref="selectEl"
            v-model="value"
            :class="classList"
            :multiple="isMultiple"
            :disabled="disabled"
            @change="$emit('onChange', value)"
        >
            <option v-if="!formattedOptions.length" disabled
                >Нет параметров</option
            >
            <option
                v-if="formattedOptions.length && emptyOptionTitle"
                :value="0"
                >{{ emptyOptionTitle }}</option
            >
            <option
                v-for="option in formattedOptions"
                :key="option.id"
                :title="
                    isMultiple && formattedOptions.length === 1
                        ? selectTitle + ' Все'
                        : ''
                "
                :value="option.id"
                >{{ option.title }}</option
            >
        </select>
    </div>
</template>

<script>
export default {
    name: 'SelectPicker',
    props: {
        currentValue: {
            // eslint-disable-next-line
            type: Number | String | Array,
            default: ''
        },
        options: {
            type: Array,
            required: true,
            default: function() {
                return []
            }
        },
        keyValue: {
            type: String,
            required: true
        },
        keyTitle: {
            type: String,
            required: true
        },
        isMultiple: {
            type: Boolean,
            default: false
        },
        selectTitle: {
            type: String,
            default: ''
        },
        selectWidth: {
            type: String,
            default: '100%'
        },
        classes: {
            // eslint-disable-next-line
            type: Array | Object,
            default: function() {
                return ['select']
            }
        },
        errorClass: {
            type: Boolean,
            default: false
        },
        search: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        emptyOptionTitle: {
            type: String,
            default: ''
        },
        showMultiSelectedTitles: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isHidden: true,
            value: this.currentValue
        }
    },
    computed: {
        formattedOptions() {
            let formattedOptionsArr = this.options.map(item => {
                return {
                    id: item[this.keyValue],
                    title: item[this.keyTitle]
                }
            })

            // if (typeof this.currentValue === 'object') {
            //     return formattedOptionsArr.sort(this.sortOptions)
            // }
            return formattedOptionsArr
        },
        classList() {
            let classes = this.isMultiple
                ? [...this.classes, 'multiple']
                : this.classes
            return this.errorClass ? [...classes, 'error'] : classes
        }
    },
    watch: {
        options: function(val, oldval) {
            if (val.length && !oldval.length) {
                window.$(this.$refs.selectEl).selectpicker('destroy')

                this.initSelectPicker()
            }
        }
    },
    mounted() {
        this.initSelectPicker()

        this.value = this.currentValue
        this.isHidden = false

        if (this.selectTitle === 'Коллекция:') {
            const selectWrap = document.querySelector(
                '.selectpicker-wrap--collections'
            )
            const dropdownMenu = selectWrap.querySelector('.dropdown-menu')

            dropdownMenu.classList.add('max-width-230px')
        }
    },
    updated() {
        this.value = this.currentValue

        this.$nextTick(() => {
            window.$(this.$refs.selectEl).selectpicker('refresh')
        })
        // window.$(this.$refs.selectEl).selectpicker('refresh')
    },
    methods: {
        initSelectPicker() {
            window.$(this.$refs.selectEl).selectpicker({
                width: this.selectWidth,
                title: this.selectTitle,
                liveSearch: this.options.length >= 20 || this.search,
                deselectAllText: 'Сбросить',
                actionsBox: true,
                size: 9,
                selectedTextFormat:
                    this.isMultiple && !this.showMultiSelectedTitles
                        ? 'static'
                        : 'values'
                // selectedTextFormat: 'count',
                // countSelectedText: function(numSelected, numTotal) {
                //     return numSelected === numTotal
                //         ? this.title + ' Все'
                //         : this.title + ' ' + numSelected
                // }
            })
        },
        sortOptions(a, b) {
            if (this.currentValue.indexOf(b.id) > -1) {
                return 1
            }
            if (this.currentValue.indexOf(a.id) > -1) {
                return -1
            }
            return 0
        },
        isArray(val) {
            return typeof val === 'object' && val !== null
        }
    }
}
</script>

<style>
.max-width-230px {
    max-width: 230px;
}

.bootstrap-select.multiple .max-width-230px .text {
    max-width: 100%;
}
</style>
